export default __webpack_public_path__ + "static/media/fantom.3f8c71bb.svg";